import {SavingInterestRateNumber,SavingPremiumInterstRateNumber,AllDepositNumber,AfterTaxSavingInterestRateNumber,AfterTaxSavingPremiumInterstRateNumber,AfterTaxAllDepositNumber} from "../utility/constant"

function RateTextInsert () {
  const savingRateString = document.querySelectorAll("[data-string='saving']")
  const savingPremiumString = document.querySelectorAll("[data-string='premium']")
  const depositPremiumString = document.querySelectorAll("[data-string='deposit']")
  const AfterTaxSavingRateString = document.querySelectorAll("[data-string='saving_afterTax']")
  const AfterTaxSavingPremiumString = document.querySelectorAll("[data-string='premium_afterTax']")
  const AfterTaxDepositPremiumString = document.querySelectorAll("[data-string='deposit_afterTax']")

  savingRateString?.forEach(str => {
    str.textContent = `${SavingInterestRateNumber}`
  });
  savingPremiumString?.forEach(str => {
    str.textContent = `${SavingPremiumInterstRateNumber}`
  });
  depositPremiumString?.forEach(str => {
    str.textContent = `${AllDepositNumber}`
  });
  AfterTaxSavingRateString?.forEach(str => {
    str.textContent = `${AfterTaxSavingInterestRateNumber}`
  });
  AfterTaxSavingPremiumString?.forEach(str => {
    str.textContent = `${AfterTaxSavingPremiumInterstRateNumber}`
  });
  AfterTaxDepositPremiumString?.forEach(str => {
    str.textContent = `${AfterTaxAllDepositNumber}`
  });
}

function DateTextInsert () {
  const DateString = document.querySelectorAll("[data-string='date']")
  const now = new Date();

  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const formattedDate = `${year}年${month}月${day}日`;
  DateString?.forEach(str => {
    str.textContent = formattedDate;
  });


}



export {RateTextInsert,DateTextInsert}
